import { useTranslation } from 'react-i18next'

import {
  TUnityHubCreateChannelsMembersStepProps,
  UnityHubCreateChannelsMembersStep
} from 'App/components/UnityHub/UnityHubCreateChannels'
import { TGetCommunityMembersPayload } from 'api/communities'

import { useCommunityCreateChannelMembersStepRequest } from './useCommunityCreateChannelMembersStepRequest'

export type TCommunityCreateChannelMembersStepProps = Pick<
  TUnityHubCreateChannelsMembersStepProps,
  | 'onBack'
  | 'onSubmit'
  | 'setChannelManagers'
  | 'setChannelMembers'
  | 'variant'
  | 'channelMembers'
  | 'channelManagerIds'
  | 'error'
  | 'maxSelected'
  | 'submitLoading'
> &
  Pick<TGetCommunityMembersPayload, 'markChatIds'> & {
    communityId: string
  }

export const CommunityCreateChannelMembersStep = ({
  channelMembers,
  communityId,
  channelManagerIds,
  variant,
  maxSelected,
  submitLoading,
  error,
  markChatIds,
  onBack,
  onSubmit,
  setChannelManagers,
  setChannelMembers
}: TCommunityCreateChannelMembersStepProps) => {
  const { t } = useTranslation()

  const {
    error: innerError,
    results,
    total,
    page,
    search,
    showBy,
    loading,
    setPage,
    handleSearch
  } = useCommunityCreateChannelMembersStepRequest({
    communityId,
    markChatIds
  })

  return (
    <UnityHubCreateChannelsMembersStep
      emptyListText={t('modal.createChannel.selectMembers.placeholder')}
      variant={variant}
      items={results}
      total={total}
      limit={showBy}
      page={page}
      search={search}
      maxSelected={maxSelected}
      error={error ?? innerError}
      channelMembers={channelMembers}
      channelManagerIds={channelManagerIds}
      submitLoading={submitLoading}
      loading={loading}
      onBack={onBack}
      onSubmit={onSubmit}
      onPageChange={setPage}
      onSearch={handleSearch}
      setChannelMembers={setChannelMembers}
      setChannelManagers={setChannelManagers}
    />
  )
}
